import { connect } from 'react-redux';

import { Entities, fetchAll, fetchAllCustomRepository, getEntities, patch } from 'src/common/index';
import AdminBookingFeedbackAdministration from 'src/components/admin/booking-feedback/admin-booking-feedback-administration';

const mapStateToProps = state => {
    return {
        bookingFeedback: getEntities(state, Entities.BOOKING_FEEDBACK),
    };
};

const AdminBookingFeedbackContainer = connect(mapStateToProps, { fetchAll, fetchAllCustomRepository, patch })(
    AdminBookingFeedbackAdministration,
);

export default AdminBookingFeedbackContainer;
